import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSchedules = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M12.5 17.5C12.5 16.6716 11.8284 16 11 16C10.1716 16 9.5 16.6716 9.5 17.5C9.5 18.3284 10.1716 19 11 19C11.8284 19 12.5 18.3284 12.5 17.5Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M12.5 22.5C12.5 21.6716 11.8284 21 11 21C10.1716 21 9.5 21.6716 9.5 22.5C9.5 23.3284 10.1716 24 11 24C11.8284 24 12.5 23.3284 12.5 22.5Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M16 21C16.8284 21 17.5 21.6716 17.5 22.5C17.5 23.3284 16.8284 24 16 24C15.1716 24 14.5 23.3284 14.5 22.5C14.5 21.6716 15.1716 21 16 21Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.5 17.5C17.5 16.6716 16.8284 16 16 16C15.1716 16 14.5 16.6716 14.5 17.5C14.5 18.3284 15.1716 19 16 19C16.8284 19 17.5 18.3284 17.5 17.5Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M22.5 17.5C22.5 16.6716 21.8284 16 21 16C20.1716 16 19.5 16.6716 19.5 17.5C19.5 18.3284 20.1716 19 21 19C21.8284 19 22.5 18.3284 22.5 17.5Z" }),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.9933 3.88338C22.9355 3.38604 22.5128 3 22 3C21.4477 3 21 3.44772 21 4V5H11V4L10.9933 3.88338C10.9355 3.38604 10.5128 3 10 3C9.44772 3 9 3.44772 9 4V5H6L5.85074 5.00549C4.81588 5.08183 4 5.94564 4 7V27L4.00549 27.1493C4.08183 28.1841 4.94564 29 6 29H26L26.1493 28.9945C27.1841 28.9182 28 28.0544 28 27V7L27.9945 6.85074C27.9182 5.81588 27.0544 5 26 5H23V4L22.9933 3.88338ZM6 13H26V27H6V13ZM9 7H6V11H26V7H23V8C23 8.55228 22.5523 9 22 9C21.4872 9 21.0645 8.61396 21.0067 8.11662L21 8V7H11V8C11 8.55228 10.5523 9 10 9C9.48716 9 9.06449 8.61396 9.00673 8.11662L9 8V7Z"
		})
	]
});
export default SvgSchedules;
